import { useRef } from "react";
import { Bg, Container, ContentBox1, List, TextBox, Wrapper } from "./style";
import { useScrollFadeIn } from "hooks/useScrollFadeIn";
import { useTranslation } from "react-i18next";
const Com6 = () => {
  const ref1 = useRef();
  const ref2 = useRef();
  const ref3 = useRef();
  const ref4 = useRef();
  useScrollFadeIn(ref1, ref2, ref3, ref4);

  const { t } = useTranslation("landing");
  return (
    <Wrapper>
      <span>{t("6-1")}</span>
      <Bg>
        <img
          loading="lazy"
          src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/ab96d7bdLanding_17.png"
          alt=""
        />
      </Bg>
      <Container>
        <img loading="lazy" src="/assets/img/Landing_11.svg" alt="" />
        <ContentBox1 ref={ref1} className="fade-in">
          <img
            loading="lazy"
            src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/40b09ae3Landing_12.png"
            alt=""
          />
          <TextBox>
            <div>{t("6-2")}</div>
            <div>{t("6-3")}</div>
            <List>
              <img loading="lazy" src="/assets/img/Landing_13.svg" alt="" />
              <span>{t("6-4")}</span>
            </List>
            <List>
              <img loading="lazy" src="/assets/img/Landing_13.svg" alt="" />
              <span>{t("6-5")}</span>
            </List>
            <List>
              <img loading="lazy" src="/assets/img/Landing_13.svg" alt="" />
              <span>{t("6-6")}</span>
            </List>
          </TextBox>
        </ContentBox1>
        <ContentBox1 ref={ref2} className="fade-in">
          <img
            loading="lazy"
            src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/7ffa9377Landing_14.png"
            alt=""
          />
          <TextBox>
            <div>{t("6-7")}</div>
            <div>{t("6-8")}</div>
            <List>
              <img loading="lazy" src="/assets/img/Landing_13.svg" alt="" />
              <span>{t("6-9")}</span>
            </List>
            <List>
              <img loading="lazy" src="/assets/img/Landing_13.svg" alt="" />
              <span>{t("6-10")}</span>
            </List>
            <List>
              <img loading="lazy" src="/assets/img/Landing_13.svg" alt="" />
              <span>{t("6-11")}</span>
            </List>
            <List>
              <img loading="lazy" src="/assets/img/Landing_13.svg" alt="" />
              <span>{t("6-12")}</span>
            </List>
          </TextBox>
        </ContentBox1>
        <ContentBox1 ref={ref3} className="fade-in">
          <img
            loading="lazy"
            src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/c5988f5eLanding_15.png"
            alt=""
          />
          <TextBox>
            <div>{t("6-13")}</div>
            <div>{t("6-14")}</div>
            <List>
              <img loading="lazy" src="/assets/img/Landing_13.svg" alt="" />
              <span>{t("6-15")}</span>
            </List>
            <List>
              <img loading="lazy" src="/assets/img/Landing_13.svg" alt="" />
              <span>{t("6-16")}</span>
            </List>
            <List>
              <img loading="lazy" src="/assets/img/Landing_13.svg" alt="" />
              <span>{t("6-17")}</span>
            </List>
          </TextBox>
        </ContentBox1>
        <ContentBox1 ref={ref4} className="fade-in">
          <img
            loading="lazy"
            src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/56c21e4aLanding_16.png"
            alt=""
          />
          <TextBox>
            <div>{t("6-18")}</div>
            <List>
              <img loading="lazy" src="/assets/img/Landing_13.svg" alt="" />
              <span>{t("6-19")}</span>
            </List>
            <List>
              <img loading="lazy" src="/assets/img/Landing_13.svg" alt="" />
              <span>{t("6-20")}</span>
            </List>
            <List>
              <img loading="lazy" src="/assets/img/Landing_13.svg" alt="" />
              <span>{t("6-21")}</span>
            </List>
            <List>
              <img loading="lazy" src="/assets/img/Landing_13.svg" alt="" />
              <span>{t("6-22")}</span>
            </List>
          </TextBox>
        </ContentBox1>
      </Container>
    </Wrapper>
  );
};

export default Com6;
